import React, { useCallback, useEffect } from "react";
import styled from "styled-components";

import {
  Button,
  Header,
  Icon,
  Modal,
  Phone,
  Pen,
  Code,
  User,
  Users,
} from "semantic-ui-react";
import ListUsers from "./ListUsers";

const BottomBar = ({
  clickChat,
  goToBack,
  toggleCameraAudio,
  userVideoAudio,
  clickScreenSharing,
  screenShare,
  videoDevices,
  showVideoDevices,
  setShowVideoDevices,
  listuserRoom,
  roomId,
}) => {
  const white = "https://common-classroom.web.app/WhiteBoard/" + roomId;
  const handleToggle = useCallback(
    (e) => {
      setShowVideoDevices((state) => !state);
    },
    [setShowVideoDevices]
  );

  function Player({ srcBlob, audio }) {
    if (!srcBlob) {
      return null;
    }

    if (audio) {
      return <audio src={URL.createObjectURL(srcBlob)} controls />;
    }

    return (
      <video
        src={URL.createObjectURL(srcBlob)}
        width={520}
        height={480}
        controls
      />
    );
  }

  return (
    <>
      <Bar>
        <Left>
          <h3>Welcome to Classroom</h3>
          <CameraButton onClick={toggleCameraAudio} data-switch="video">
            <div>
              {userVideoAudio.video ? (
                <FaIcon className="fas fa-video"></FaIcon>
              ) : (
                <FaIcon className="fas fa-video-slash"></FaIcon>
              )}
            </div>
          </CameraButton>
          {showVideoDevices && (
            <SwitchList>
              {videoDevices.length > 0 &&
                videoDevices.map((device) => {
                  console.log(device);
                  return <div>{device.label}</div>;
                })}
              <div>Switch Camera</div>
            </SwitchList>
          )}
          {/* <SwitchMenu onClick={handleToggle}>
          <i className="fas fa-angle-up"></i>
        </SwitchMenu> */}
          <CameraButton onClick={toggleCameraAudio} data-switch="audio">
            <div>
              {userVideoAudio.audio ? (
                <FaIcon className="fas fa-microphone"></FaIcon>
              ) : (
                <FaIcon className="fas fa-microphone-slash"></FaIcon>
              )}
            </div>
          </CameraButton>
        </Left>
        <Center>
          <ScreenButton onClick={clickScreenSharing}>
            <div>
              <FaIcon
                className={`fas fa-desktop ${screenShare ? "sharing" : ""}`}
              ></FaIcon>
            </div>
            Share Screen
          </ScreenButton>
          <a href={white} target="_blank" rel="noopener noreferrer">
            <WhiteBoard>
              <div>
                <FaIcon className={"fas fa-pen"}></FaIcon>
              </div>
              WhiteBoard
            </WhiteBoard>
          </a>
          <Scripting className="scripting">
            <FaIcon className={"fas fa-code"}></FaIcon> <br /> Start Scripting{" "}
          </Scripting>
        </Center>
        <Right>
          <StopButton onClick={goToBack}>
            <FaIcon className={"fas fa-phone"}></FaIcon>
          </StopButton>
        </Right>
      </Bar>
      <Bar2>
        <div className="ListMenu">
          <ListUsers userlistromm={listuserRoom} />
        </div>
        <ChatButton onClick={clickChat}>
          <div>
            <FaIcon className="fas fa-comments"></FaIcon>
          </div>
        </ChatButton>
        <h2 className="timer">7:00</h2>

        <FaIcon className="fas fa-user"></FaIcon>
        <FaIcon className="fas fa-users"></FaIcon>
      </Bar2>
    </>
  );
};

const Bar = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 12%;
  padding-bottom: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  background-color: #191919;
  box-shadow: 0 0 50px rgba(0, 0, 0, 1.25);
`;
const Left = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;
  h3 {
    background-image: linear-gradient(
      to right,
      #eb34d9,
      #eb34d9,
      #c30ffa,
      #c30ffa,
      #eb34d9,
      #eb34d9
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;
const Scripting = styled.div`
  position: relative;
  font-size: 1rem;
  color: #ee2560;
  left: 0vw;
  overflow: hidden;
  margin-top: 28px;
  &:hover {
    cursor: pointer;
    background-color: #555;
  }
`;
const WhiteBoard = styled.div`
  width: 100px;
  /* height: 11%; */
  border: none;
  color: #ee2560;
  font-size: 0.9375rem;
  position: relative;
  left: 16vw;
  margin-top: 25px;
  padding: 5px;

  :hover {
    box-shadow: 0 0 15px #555;
    background-color: #555;
    color: #ee2560;
    cursor: pointer;
  }
  * {
    pointer-events: none;
  }
`;
const Center = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Right = styled.div``;

const ChatButton = styled.div`
  width: 60px;
  height: 60px;
  border: none;
  font-size: 0.9375rem;
  padding: 5px;
  color: #eee;
  position: relative;
  top: 13px;
  left: 10px;

  :hover {
    color: #4ea1d3;
    cursor: pointer;
    border-radius: 50%;
  }

  * {
    pointer-events: none;
  }
`;
const StartButton = styled.div`
  width: 75px;
  border: none;
  font-size: 0.9375rem;
  padding: 5px;

  :hover {
    box-shadow: 0 0 15px #555;
    cursor: pointer;
    border-radius: 50%;
  }

  * {
    pointer-events: none;
  }
`;

// const StopRecordButton = styled.div`
//   width: 75px;
//   border: none;
//   font-size: 0.9375rem;
//   padding: 5px;

//   :hover {
//     background-color: #77b7dd;
//     cursor: pointer;
//     border-radius: 15px;
//   }

//   * {
//     pointer-events: none;
//   }
// `;

const ScreenButton = styled.div`
  width: auto;
  border: none;
  font-size: 0.9375rem;
  padding: 5px;
  color: #ee2560;
  position: relative;
  left: 65vh;
  overflow: hidden;
  margin-top: 25px;
  :hover {
    box-shadow: 0 0 15px #555;
    cursor: pointer;
    background-color: #555;
    color: #ee2560;
  }

  .sharing {
    color: #ee2560;
  }
`;

const FaIcon = styled.i`
  width: 30px;
  font-size: calc(16px + 1vmin);
`;

const StopButton = styled.div`
  position: relative;
  left: -49.2vw;
  width: 55px;
  height: 55px;
  border: none;
  font-size: 5.3rem;
  background-color: #555;
  border-radius: 50%;
  margin-top: 10px;

  :hover {
    background-color: #f00722;
    cursor: pointer;
  }
`;

const CameraButton = styled.div`
  position: relative;
  left: 20vw;
  margin-top: 10px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: #555;
  border: none;
  font-size: 3.8rem;
  padding: 5px;
  margin-right: 1rem;
  color: #eee;

  :hover {
    box-shadow: 0 0 15px #555;
    cursor: pointer;
    border-radius: 50%;
  }

  * {
    pointer-events: none;
  }

  .fa-microphone-slash {
    color: #ee2560;
  }

  .fa-video-slash {
    color: #ee2560;
  }
`;

const SwitchMenu = styled.div`
  display: flex;
  position: absolute;
  width: 20px;
  top: 7px;
  left: 80px;
  z-index: 1;

  :hover {
    box-shadow: 0 0 15px #555;
    cursor: pointer;
    border-radius: 50%;
  }

  * {
    pointer-events: none;
  }

  > i {
    width: 90%;
    font-size: calc(10px + 1vmin);
  }
`;

const SwitchList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: -115px;
  left: 80px;
  background-color: #4ea1d3;
  color: white;
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  text-align: left;

  > div {
    font-size: 0.85rem;
    padding: 1px;
    margin-bottom: 5px;

    :not(:last-child):hover {
      background-color: #7a5514;
      cursor: pointer;
    }
  }

  > div:last-child {
    border-top: 1px solid white;
    cursor: context-menu !important;
  }
`;
const Bar2 = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 10%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  background-color: #191919;
  word-spacing: 1rem;
  border-bottom-right-radius: 10px;

  .fa-users {
    position: relative;
    right: -4vw;
    &:hover {
      cursor: pointer;
    }
  }
  .fa-user {
    position: relative;
    right: 15vw;
    &:hover {
      cursor: pointer;
    }
  }
  .ListMenu {
    position: relative;
    left: -9vw;
  }
  .timer {
    position: relative;
    left: 4rem;
    margin-top: 10px;
  }
`;

export default BottomBar;
